/* eslint-disable react/prop-types */
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Spin,
} from 'antd';
import { getEstadosGlobales } from 'api/catalogos/index';
import { getCatalogosDeModalidadDeSeguridadSocial } from 'api/catalogos/ModalidadDeSeguridadSocial';
import {
  deleteSeguridadsocial,
  getSeguridadsociales,
  patchSeguridadsocial,
  postSeguridadsocial,
} from 'api/catalogos/SeguridadSocial';
import { getTiposDeSeguridadSocial } from 'api/catalogos/tipoDeSeguridadSocial';
import { checkToken } from 'api/utils';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import Table from 'components/Table';
import React, { useEffect, useState } from 'react';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
} from 'utils/constants';
import { formatReceived } from 'utils/formatValues';
import { onError } from 'utils/handlers';
import { DATE_FRONTEND_FORMAT } from 'utils/normalizers';
import { NOMBRES_PATTERN } from 'utils/patterns';

export const SeguridadSocialPermission = {
  permissionModel: 'catalogodesegurosdeseguridadsocial',
};

const removeEmptyChildren = (node) => {
  if (node.children?.length === 0) {
    // eslint-disable-next-line no-param-reassign
    delete node.children;
  } else {
    // eslint-disable-next-line no-param-reassign
    node.children = node.children.map(removeEmptyChildren);
  }
  return node;
};
const normalize = (_data) => {
  const nodeMap = new Map();
  const securityMap = new Map();

  _data.forEach((node) => {
    nodeMap.set(node.id, {
      ...node,
      children: [],
      _id: crypto.randomUUID(),
      key: `${node.seguridad_social}/${node.id}`.trim(),
    });
  });

  _data.forEach((node) => {
    const currentNode = nodeMap.get(node.id);

    if (node.seguros_de_seguridad_social_padre !== null) {
      const parent = nodeMap.get(node.seguros_de_seguridad_social_padre);
      if (parent) {
        parent.children.push(currentNode);
      }
    } else {
      if (!securityMap.has(node.seguridad_social)) {
        securityMap.set(node.seguridad_social, {
          seguridad_social: node.seguridad_social,
          children: [],
          _id: crypto.randomUUID(),
          key: `${node.seguridad_social}`.trim(),
        });
      }
      securityMap.get(node.seguridad_social).children.push(currentNode);
    }
  });

  return Array.from(securityMap.values()).map((item) => ({
    ...item,
    id: item.seguridad_social,
    children: item.children.length > 0 ? item.children : undefined,
  })).map(removeEmptyChildren);
};

const SeguridadSocial = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const [disableFields, setDisableFields] = useState(false);
  const [tipos, setTipos] = useState([]);
  const [tiposmodalidad, setTiposModalidad] = useState([]);

  const fetchData = async () => {
    setLoading(true);
    const _data = await getSeguridadsociales();
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _data,
        _tipos,
        _tiposmodalidad,
      ] = await Promise.all([
        getEstadosGlobales(),
        getSeguridadsociales(),
        getTiposDeSeguridadSocial(),
        getCatalogosDeModalidadDeSeguridadSocial(),
      ]);
      if (mounted) {
        setEstados(_estados);
        setTipos(_tipos);
        setTiposModalidad(_tiposmodalidad);
        setData(normalize(_data));

        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);
  const onCancel = () => {
    setVisible(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    /// setData([]);
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;
      const saved = await (key ? patchSeguridadsocial(key, values) : postSeguridadsocial(values));
      if (saved) {
        onCancel();
        await fetchData();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteSeguridadsocial(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.key]);
    setSelectedData({ ...record });
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    form.resetFields();
    onCancel();
    setVisible(true);
  };

  const columns = [
    {
      titleText: 'Seguridad Social',
      dataIndex: 'seguridad_social',
      key: 'seguridad_social',
      width: 400,
      render: (val) => tiposmodalidad.find((e) => e.id === val)?.seguridad_social,
      // render: (val) => tipos.find((e) => e.id === val)?.concepto || 'N/A',
    },
    {
      titleText: 'Seguro',
      dataIndex: 'nombre',
      key: 'nombre',
      width: 400,
    },
    {
      titleText: 'Sub Seguro',
      dataIndex: 'seguros_de_seguridad_social_padre',
      key: 'seguros_de_seguridad_social_padre',
      width: 400,

    },
    {
      titleText: 'Vigencia Hasta',
      dataIndex: 'vigencia_hasta',
      key: 'vigencia_hasta',
      width: 400,
      render: (val) => (val ? val?.format(DATE_FRONTEND_FORMAT) : 'N/A'),
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    nombre: [
      requiredRule,
      {
        pattern: NOMBRES_PATTERN,
        message: 'Ingrese un nombre válido',
      },
    ],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            //  onClickEdit: () => onClickEdit(),
            //  onClickDelete,
          }}
          disableDelete={selectedData?.estados_globales === ESTATUS_AUTORIZADO}
          permission={permission}
          filterNested
        />
        <Modal
          open={open}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Nivel de Estudio`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
              allowSave={!disableFields}
            />
          )}
          onCancel={onCancel}
          forceRender
        >
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            scrollToFirstError
            name="general"
            initialValues={{
              estados_globales: ESTATUS_ACTIVO,
            }}
          >
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="nombre"
                label="Nombre"
                hasFeedback
              >
                <Input
                  allowClear
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="seguridad_social"
                label="Seguridad Social"
                hasFeedback
              >
                <Select
                  labelProp="concepto"
                  dataSource={tipos}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="seguro"
                label="Seguro"
                hasFeedback
              >
                <Input
                  allowClear
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="vigencia_hasta"
                label="Vigente Hasta"
                hasFeedback
              >
                <DatePicker
                  format={DATE_FRONTEND_FORMAT}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="estados_globales"
                label="Estatus"
                rules={rules.required}
                hasFeedback
              >
                <Select
                  labelProp="descripcion"
                  keyProp="id"
                  dataSource={estados}
                  disabled={selectedRowKeys.length <= 0 || disableFields}
                />
              </Form.Item>
            </Col>
            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Form>
        </Modal>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content="El Registro Seleccionado"
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default SeguridadSocial;
